// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".app-container[data-v-3a6147a9]  .permission-alert {\n  width: 320px;\n  margin-top: 15px;\n  background-color: #f0f9eb;\n  color: #67c23a;\n  padding: 8px 16px;\n  border-radius: 4px;\n  display: inline-block;\n}\n.app-container[data-v-3a6147a9]  .permission-sourceCode {\n  margin-left: 15px;\n}\n.app-container[data-v-3a6147a9]  .permission-tag {\n  background-color: #ecf5ff;\n}", ""]);
// Exports
module.exports = exports;
